module.exports = __webpack_public_path__ + "img/Ng.205ca0f3.jpg";